import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import { RichTextField } from "@/components/typography/RichTextField";
import type { LogoListStoryblok } from "@/component-types-sb";

type LogoListProps = {
  blok: LogoListStoryblok;
};

const LogoList = ({ blok }: LogoListProps) => {
  const itemCount = blok.items?.length || 0;
  const hasPremium = blok.premium_headline && blok.premium_items && blok.premium_items.length > 0;
  const hasHeader = blok.headline || blok.text;

  return (
    <div {...storyblokEditable(blok)} className="w-full">
      <section className="py-6 w-full">
        {/* Premium sponsors */}
        {hasPremium && (
          <div className="max-w-7xl mx-auto px-4 md:px-8 mb-8">
            <h2 className="text-copy-bold text-center mb-6">
              {blok.premium_headline}
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4">
              {blok.premium_items!.map((nestedBlok: any) => (
                <div
                  key={nestedBlok._uid}
                  className="h-[100px] flex items-center justify-center"
                >
                  <StoryblokComponent blok={nestedBlok} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Regular sponsors */}
        {hasHeader && (
          <GridContainer className="mb-6">
            <div className="col-span-12 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4 text-center flex flex-col [&>*+*]:mt-6">
              {blok.headline && (
                <h2 className={hasPremium ? "text-copy" : "text-headline-md"}>
                  {blok.headline}
                </h2>
              )}
              {blok.text && <RichTextField value={blok.text} className="text-copy" />}
            </div>
          </GridContainer>
        )}

        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className={`${itemCount === 1 ? "flex justify-center" : "grid grid-cols-2"} md:flex md:flex-wrap md:justify-center items-center gap-x-4 md:gap-x-8 gap-y-4`}>
            {blok.items?.map((nestedBlok: any) => (
              <div
                key={nestedBlok._uid}
                className="h-[100px] flex items-center justify-center"
              >
                <StoryblokComponent blok={nestedBlok} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LogoList;
